<template>
  <div>
    <v-container v-if="!prompts">
      <v-flex pb-3>
        <h1>Custom Practice Session - Verbs</h1>
        <h3>Select which category, tense, form and question types you wish to practice.</h3>
      </v-flex>
      <v-form >
<div v-if="isMobile()">
  <mobile>
    <div :rules="[rules.catValid]">
          <h3>Category</h3>
          <v-checkbox v-for="cat in categories" :label="cat" v-model="selectedCats" :value="cat"></v-checkbox>
          <div v-if="!$v.selectedCats.required" class="red--text">Must select at least one option</div>
    </div>
    
    <div :rules="[rules.tenseValid]">
          <h3>Tense/Mood</h3>
          <template v-for="(ten, index) in tenses">
            <v-checkbox v-model="selectedTenses" :label="ten" :value="ten" 
            :disabled="checkboxDependent() && index == 4"></v-checkbox>
          </template>
          <span v-if="!$v.selectedTenses.required" class="red--text">Must select at least one option</span>
    </div>

        <div :rules="[rules.formValid]">
          <h3>Form</h3>
          <v-checkbox :disabled="checkboxSubjunctive()" v-for="frm in forms" v-model="selectedForms" :label="frm" :value="frm"></v-checkbox>
          <span v-if="!$v.selectedForms.required" class="red--text">Must select at least one option</span>
        </div>
        <div :rules="[rules.typeValid]">
          <h3>Question Types</h3>
          <v-checkbox
            v-for="typ in questionTypes"
            v-model="selectedTypes"
            :label="typ"
            :value="typ"
          ></v-checkbox>
          <span v-if="!$v.selectedTypes.required" class="red--text">Must select at least one option</span>
        </div>
  </mobile>
</div>

<div v-if="!isMobile()">

        <v-layout :rules="[rules.catValid]">
          <h3>Category</h3>
          <v-checkbox v-for="cat in categories" :label="cat" v-model="selectedCats" :value="cat"></v-checkbox>
          <div v-if="!$v.selectedCats.required" class="red--text">Must select at least one option</div>
        </v-layout>
        <v-layout :rules="[rules.tenseValid]">
          <h3>Tense/Mood</h3>
          
          <template v-for="(ten, index) in tenses">
            <v-checkbox v-model="selectedTenses" :label="ten" :value="ten" 
            :disabled="checkboxDependent() && index == 4"></v-checkbox>
          </template>


          <!-- <v-checkbox v-for="ten in tenses" v-model="selectedTenses" :label="ten" :value="ten"></v-checkbox> -->
          <span v-if="!$v.selectedTenses.required" class="red--text">Must select at least one option</span>
        </v-layout>
        <v-layout :rules="[rules.formValid]">
          <h3>Form</h3>
          <!-- <v-checkbox :disabled="selectedTenses == 'present subjunctive'" v-for="frm in forms" v-model="selectedForms" :label="frm" :value="frm"></v-checkbox> -->
          <v-checkbox :disabled="checkboxSubjunctive()" v-for="frm in forms" v-model="selectedForms" :label="frm" :value="frm"></v-checkbox>
          <span v-if="!$v.selectedForms.required" class="red--text">Must select at least one option</span>
        </v-layout>
        <v-layout :rules="[rules.typeValid]">
          <h3>Question Types</h3>
          <v-checkbox
            v-for="typ in questionTypes"
            v-model="selectedTypes"
            :label="typ"
            :value="typ"
          ></v-checkbox>
          <span v-if="!$v.selectedTypes.required" class="red--text">Must select at least one option</span>
        </v-layout>

</div>


        <v-text-field v-model.number="length" type="number" label="Number of Questions" :rules="[rules.range]"></v-text-field>

        <v-btn outline round color="primary" disabled>Recommend</v-btn>
        <v-btn outline round color="primary" @click="clearOptions">Clear Options</v-btn>
        <v-btn outline round color="primary" @click="checkAll">Reset</v-btn>
<br>
    <p class="red--text" v-if="$v.$invalid">Please complete form</p>
        <v-btn
          large
          round
          outline
          color="primary"
          @click="genSet"

        >Start Practice Session</v-btn>
      </v-form>
    </v-container>

  </div>
</template>

<script>
import ParametersToConjugation from "@/components/QuizTypes/ParametersToConjugation";
import ConjugationToParameters from "@/components/QuizTypes/ConjugationToParameters";
import TranslationToConjugation from "@/components/QuizTypes/TranslationToConjugation";
import ConjugationToTranslation from "@/components/QuizTypes/ConjugationToTranslation";
import { generatePromptSet } from "@/verbprompts.js";
import {
  PARTS_OF_SPEECH,
  GENDER,
  VERB_TENSES,
  VERB_PERSON,
  VERB_NUMBER,
  VERB_CATEGORY,
  SAMPLE_VERBS,
  VERB_FORMS,
} from "@/constants.js";
import { required, minLength, between } from "vuelidate/lib/validators";

export default {
  components: {
    ParametersToConjugation,
    ConjugationToParameters,
    TranslationToConjugation,
    ConjugationToTranslation,
  },
  data() {
    return {
      formValid: false,
      selectedTenses: Object.values(VERB_TENSES),
      selectedForms: Object.values(VERB_FORMS),
      selectedCats: Object.values(VERB_CATEGORY),
      categories: Object.values(VERB_CATEGORY),
      selectedTypes: [
        "parameters to conjugation",
        "conjugation to parameters",
        "translation to conjugation",
        "conjugation to translation",
      ],
      tenses: Object.values(VERB_TENSES),
      forms: Object.values(VERB_FORMS),
      questionTypes: [
        "parameters to conjugation",
        "conjugation to parameters",
        "translation to conjugation",
        "conjugation to translation",
      ],
      length: 6,
      rules: {
        range: (value) => (value > 0 && value <= 50) || "Limit 1 to 50",
        catValid: () =>
          this.selectedCats.length > 0 || "At least one option must be checked",
        tenseValid: () =>
          this.selectedTenses.length > 0 ||
          "At least one option must be checked",
        formValid: () =>
          this.selectedForms.length > 0 ||
          "At least one option must be checked",
        typeValid: () =>
          this.selectedTypes.length > 0 ||
          "At least one option must be checked"
      },
      quizResults: [],
      quizComplete: false,
      prompts: null
    };
  },
  validations: {
    selectedTenses: {
      required,
      minLength: minLength(1),
    },
     selectedForms: {
      required,
      minLength: minLength(1),
    },
     selectedCats: {
      required,
      minLength: minLength(1),
    },
     selectedTypes: {
      required,
      minLength: minLength(1),
    },
  },
  methods: {
    checkboxDependent(){
      if(!this.selectedForms.includes('independent')){
        if(this.selectedTenses.includes('present subjunctive')){
          for( var i = 0; i < this.selectedTenses.length; i++){ 
            if ( this.selectedTenses[i] == 'present subjunctive') { 
                this.selectedTenses.splice(i, 1); 
            }
          }
        }
        return true;
      }else{
        return false;
      }
    },
    checkboxSubjunctive(){
      // Subjunctive only -> disable negative and interrogative
      if(this.selectedTenses == 'present subjunctive'){
        if(this.selectedForms.length == 1 && this.selectedForms.includes('independent')){
          return true;
        }else{
          this.selectedForms = ['independent']; 
        }
        return true;
      }else{
        return false;
      }
    },
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    clearOptions: function () {
      this.selectedCats = this.selectedTenses = this.selectedForms = this.selectedTypes = [];
    },
    checkAll: function () {
      Object.assign(this.$data, this.$options.data.call(this));
    },
    genSet: function () {
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
        this.$v.$touch();
      } else {
        var obj = {
          categories: this.selectedCats,
          tenses: this.selectedTenses,
          forms: this.selectedForms,
          types: this.selectedTypes,
        };
        var res = generatePromptSet(obj, this.length);
        this.$store.commit("setPracticeQueue",res)
        this.$store.commit("setVerbQuestionTypes",obj.types)
        console.table(this.prompts);
        this.$router.push('/PracticeQuiz/Verb')
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>